"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _voyagePlanSearch = require("@/api/vessel/voyagePlanSearch");
var _booking = require("@/api/bookSpace/booking");
var _validate = require("@/utils/validate");
var _date = require("@/utils/date");
var _utils = require("@/utils");
var _auth = require("@/utils/auth");
var _elementUi = require("element-ui");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'voyagePlanSearch',
  data: function data() {
    return {
      form: {
        pol: undefined,
        pod: undefined,
        datefrom: undefined,
        dateto: undefined,
        type: false
      },
      subscribeEnable: true,
      searchType: false,
      lastweeks: '1',
      rules: {
        pol: [{
          required: true,
          message: this.$t('validate.pol'),
          trigger: 'blur'
        }],
        pod: [{
          required: true,
          message: this.$t('validate.pod'),
          trigger: 'blur'
        }],
        datefrom: [{
          required: true,
          message: this.$t('validate.date'),
          trigger: 'blur'
        }]
      },
      tableData: [],
      activeNames: [],
      tsTableData: [],
      showTips: false,
      showTsTips: false,
      isResult: false,
      isTsResult: true,
      loading: null
    };
  },
  methods: {
    subscribe: function subscribe() {
      var _this = this;
      var hasToken = (0, _auth.getToken)();
      if (hasToken) {
        (0, _voyagePlanSearch.subscribeSchedule)({
          polName: this.form.pol,
          podName: this.form.pod
        }).then(function (response) {
          if (response.success === true) {
            _this.$alert(_this.$t('voyagePlanSearch.subscribeSuccess'), _this.$t('voyagePlanSearch.subscribeTips'), {
              confirmButtonText: _this.$t('voyagePlanSearch.sure'),
              callback: function callback(action) {}
            });
          } else {
            _this.$alert(JSON.stringify(response.data), _this.$t('voyagePlanSearch.subscribeTips'), {
              confirmButtonText: _this.$t('voyagePlanSearch.sure'),
              callback: function callback(action) {}
            });
          }
        });
      } else {
        var message = this.$i18n.locale === 'zh' ? '请先登录,再进行操作' : 'Please login first and then operate';
        _elementUi.Message.warning(message);
      }
    },
    getTotalDaysByDateRange: function getTotalDaysByDateRange(startDate, endDate) {
      //包含开始日期 结束日期在内的总天数
      var total = Math.ceil(Math.abs(new Date(startDate).getTime() - new Date(endDate).getTime()) / 86400000);
      return total === 0 ? 1 : total;
    },
    polChange: function polChange(val, selectRows) {
      this.form.pol = selectRows.portName;
      this.subscribeEnable = false;
    },
    podChange: function podChange(val, selectRows) {
      this.form.pod = selectRows.portName;
      this.subscribeEnable = false;
    },
    validateNull: _validate.validateNull,
    calculateDates: _date.calculateDates,
    handleVesselName: function handleVesselName(vesselName) {
      var _this2 = this;
      if (vesselName === 'BARGE') {} else {
        (0, _booking.queryListVessel)({
          vesselName: vesselName.substring(0, vesselName.length - 6)
        }).then(function (response) {
          if (!(0, _validate.validateNull)(response.data.records)) {
            var routeUrl = _this2.$router.resolve({
              path: '/topMenu/vesselMovementSearch',
              query: {
                vesselCode: response.data.records[0].vesselCode,
                vesselName: response.data.records[0].vesselName
              }
            });
            window.open(routeUrl.href, '_blank');
          }
        });
      }
    },
    getPortTerminal: function getPortTerminal(index, transType, terminalName) {
      if (+transType.charAt(1) === 1) {
        return index - +transType.charAt(0) < 0 ? '' : terminalName.split('->')[index - +transType.charAt(0)];
      } else {
        if (index - +transType.charAt(0) < 0) {
          return '';
        } else if (index - +transType.charAt(0) === 0) {
          return terminalName.split('->')[index - +transType.charAt(0)];
        } else {
          if (index - +transType.charAt(0) <= +transType.charAt(1) - 1) {
            if (terminalName.split('->')[index - +transType.charAt(0)] === terminalName.split('->')[index + 1 - +transType.charAt(0)]) {
              return terminalName.split('->')[index - +transType.charAt(0)];
            } else {
              return index - +transType.charAt(0) < 0 ? '' : terminalName.split('->')[index - +transType.charAt(0)] + ' --> ' + terminalName.split('->')[index + 1 - +transType.charAt(0)];
            }
          } else {
            return index - +transType.charAt(0) < 0 ? '' : terminalName.split('->')[index + +transType.charAt(1) - 1 - +transType.charAt(0)];
          }
        }
      }
    },
    getDiffDay: function getDiffDay(new_date, old_date) {
      var myDate_1 = new Date(new_date);
      var myDate_2 = new Date(old_date);
      var subtime = (myDate_1 - myDate_2) / 1000; //计算时间差,并将毫秒转化为秒
      return parseInt(subtime / 86400); //天  24*60*60*1000
    },
    getDiffHour: function getDiffHour(new_date, old_date) {
      var myDate_1 = new Date(new_date);
      var myDate_2 = new Date(old_date);
      var subtime = (myDate_1 - myDate_2) / 1000; //计算时间差,并将毫秒转化为秒
      var days = parseInt(subtime / 86400); //天  24*60*60*1000
      return parseInt(subtime / 3600) - 24 * days; //小时  60*60  总小时数-过去小时数=现在小时数
    },
    dateFormat: _date.dateFormat,
    /**
     * 航名/航次链接到船舶动态
     */
    skipVesselMovement: function skipVesselMovement(row) {
      var routeUrl = this.$router.resolve({
        path: '/topMenu/vesselMovementSearch',
        query: {
          vesselCode: row.vesselCode,
          vesselName: row.vesselName
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    toTsSearch: function toTsSearch() {
      this.searchType = true;
      this.toSearch();
    },
    /**
     * 船期搜索
     */
    toSearch: function toSearch() {
      var _this3 = this;
      this.subscribeEnable = true;
      this.showTips = false;
      this.showTsTips = false;
      this.tsTableData = [];
      this.tableData = [];
      this.activeNames = [];
      this.$refs.form.validate(function (vaild) {
        if (vaild) {
          _this3.form.dateto = (0, _date.calculateDates)(_this3.form.datefrom, _this3.lastweeks * 7);
          if (_this3.searchType) {
            _this3.loading = (0, _utils.load)();
            (0, _voyagePlanSearch.voyageTsInfoSearch)(_this3.form).then(function (response) {
              if ((0, _validate.validateNull)(response.data.list)) {
                _this3.showTsTips = true;
              } else {
                _this3.isTsResult = true;
                _this3.tsTableData = response.data.list;
              }
            }).finally(function () {
              _this3.loading.close();
            });
          } else {
            _this3.loading = (0, _utils.load)();
            (0, _voyagePlanSearch.voyageInfoSearch)(_this3.form).then(function (response) {
              if ((0, _validate.validateNull)(response.data.list)) {
                _this3.showTips = true;
              } else {
                _this3.isResult = true;
                _this3.tableData = response.data.list.filter(function (item) {
                  return +item.underway > 0;
                });
              }
            }).finally(function () {
              _this3.loading.close();
            });
          }
        }
      });
    },
    weekFormatter: function weekFormatter(str) {
      var weeki = new Date(str).getDay();
      switch (weeki) {
        case 0:
          return 'Sun';
        case 1:
          return 'Mon';
        case 2:
          return 'Tue';
        case 3:
          return 'Wed';
        case 4:
          return 'Thur';
        case 5:
          return 'Fri';
        case 6:
          return 'Sat';
      }
    },
    changeType: function changeType(value) {
      if (value) {
        var date = new Date();
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        var d = date.getDate() + 7;
        this.form.datefrom = y + '-' + m + '-' + d;
      } else {
        this.form.datefrom = (0, _date.getToday)();
      }
    },
    getTime: function getTime() {
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      var date1 = y + '-' + m + '-' + d;
      this.form.datefrom = date1;
      this.form.dateto = (0, _date.calculateDates)(this.form.datefrom, this.lastweeks * 7);
    },
    init: function init() {
      var _this4 = this;
      console.log(this.$route.params, '88888');
      if (!(0, _validate.validateNull)(this.$route.params)) {
        this.form.pol = this.$route.params.pol;
        this.form.pod = this.$route.params.pod;
        if ((0, _validate.validateNull)(this.$route.params.datefrom) || (0, _validate.validateNull)(this.$route.params.dateto)) {
          this.getTime();
        } else {
          this.form.datefrom = this.$route.params.datefrom;
          this.form.dateto = this.$route.params.dateto;
        }
        this.tableData = [];
        this.loading = (0, _utils.load)();
        (0, _voyagePlanSearch.voyageInfoSearch)(this.form).then(function (response) {
          if ((0, _validate.validateNull)(response.data.list)) {} else {
            _this4.isResult = true;
            _this4.tableData = response.data.list;
          }
        }).finally(function () {
          _this4.loading.close();
        });
      }
      if (!this.validateNull(this.$route.query)) {
        this.form.pol = this.$route.query.pol;
        this.form.pod = this.$route.query.pod;
        this.getTime();
        this.tableData = [];
        this.loading = (0, _utils.load)();
        (0, _voyagePlanSearch.voyageInfoSearch)(this.form).then(function (response) {
          if ((0, _validate.validateNull)(response.data.list)) {} else {
            _this4.isResult = true;
            _this4.tableData = response.data.list;
          }
        }).finally(function () {
          _this4.loading.close();
        });
      }
    }
  },
  created: function created() {
    this.init();
  },
  mounted: function mounted() {
    if (this.form.type) {
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate() + 7;
      this.form.datefrom = y + '-' + m + '-' + d;
    } else {
      this.form.datefrom = (0, _date.getToday)();
    }
  }
};